var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauMaroc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10290_49458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4C27.2843 4 34 10.7157 34 19C34 27.2843 27.2843 34 19 34C10.7157 34 4 27.2843 4 19C4 10.7157 10.7157 4 19 4ZM17.3262 16.7061H11.9141L16.293 19.8838L14.6201 25.0322L18.999 21.8496L23.3789 25.0322L21.7051 19.8838L26.085 16.7061H20.6729L18.999 11.5566L17.3262 16.7061ZM18.1455 21.2285L16.542 22.3906L17.1523 20.5088L18.1455 21.2285ZM21.4619 22.3906L19.8584 21.2285L20.8516 20.5088L21.4619 22.3906ZM19.9375 17.7139L20.5186 19.501L18.999 20.6035L17.4805 19.501L18.0557 17.7139H19.9375ZM16.998 17.7139L16.6211 18.875L15.0225 17.7139H16.998ZM22.9766 17.7139L21.3779 18.875L21 17.7139H22.9766ZM19.6152 16.7061H18.3887L19.0049 14.8184L19.6152 16.7061Z",
    fill: "url(#paint0_linear_10290_49458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6201 25.0323L16.2934 19.8834L11.9141 16.7056H17.3262L18.9995 11.5566L20.6728 16.7056H26.0849L21.7055 19.8834L23.3788 25.0323L18.9995 21.8496L14.6201 25.0323ZM19.8585 21.2289L21.4622 22.3908L20.8515 20.509L19.8585 21.2289ZM17.1524 20.509L16.5417 22.3908L18.1454 21.2289L17.1524 20.509ZM17.4801 19.501L18.9995 20.6033L20.5188 19.501L19.9379 17.7135H18.0561L17.4801 19.501ZM15.0223 17.7135L16.6211 18.8754L16.9985 17.7135H15.0223ZM21.3778 18.8754L22.9766 17.7135H21.0005L21.3778 18.8754ZM18.3887 16.7056H19.6152L19.0044 14.8188L18.3887 16.7056Z",
    fill: "#00833E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10290_49458",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.329412 0 0 0 0 0.898039 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10290_49458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10290_49458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10290_49458",
    x1: 4.00134,
    y1: 18.9986,
    x2: 33.9981,
    y2: 18.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauMaroc);
export default __webpack_public_path__ + "static/media/drapeauMaroc.677d41394d49a8a9ce93cee55f3c732a.svg";
export { ForwardRef as ReactComponent };